module.exports = __webpack_public_path__ + "bat.jpg?6a34535868beccd87e506022bf2be20f";